import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Loader from "components/Loader";
import BannerShelf from "components/BannerShelf";
import ShelfHeader from 'components/ShelfHeader';
import BreadCrumbCatalog from 'components/Catalog/BreadCrumbCatalog';
import Shortcuts from 'components/Catalog/Shortcuts';
import TextComponent from 'components/TextComponent';
import Shelf from "containers/Shelf";
import RenderService from 'services/Render'
import queryString from 'query-string'
import CmsService from 'services/CMS'
import style from './style.scss';//NOSONAR

const getInitialState = () => {
    const data = RenderService.getRenderData();

    if(!(data && data.plp && data.plp.filters)){
        return {};
    }

    let quantity = 0;

    if(data.plp.plp_products && data.plp.plp_products.resources){
        quantity = parseInt(data.plp.plp_products.resources.split('/')[1] || '0');
    }

    return {
        quantity
    };
}

const CatalogContainer = (props) => {
    const {
        searchTerm,
        isLoaded,
        categories,
        sideFilters,
        filters,
        filterByBrand,
        filterService,
        location,
        specifications,
        title,
    } = props
    const initialState = getInitialState();
    const [quantity, setQuantity] = useState(initialState.quantity || 0);
    const [dataTexComponent, setDataTexComponent] = useState();


    useEffect(() => {
        getContentData();
    },[])

    const getContentData = () =>{
        const pathname = location.pathname ? location.pathname.replace('/', '').split('/').filter(Boolean).pop() : '';
        if(!pathname) return false;
        let consults = [];

        if (pathname === 'busca') {
            const searchParams = queryString.parse(location.search);
            const collection = searchParams.fq ? searchParams.fq.replace('H:','') : '';

            if(collection){
                consults.push(CmsService.getPLP(collection, 'collection'))
            }

        } else {
            consults.push(CmsService.getPLP(pathname, 'category'))
        }

        Promise.all(consults).then(response => {
            const textComponent = (response && response[0] && response[0].acf?.component_text) ? response[0].acf.component_text : {};
            setDataTexComponent(textComponent)
        })
    }

    const changeQuantity = (value) => {
        setQuantity(value);
    }

    return (
        <div className="container">
            {!isLoaded && <div className="catalog-page-loader">
                <Loader />
            </div>}
            {isLoaded && <div className="catalog-page-content">
                <main className="shelf-main">
                    <BreadCrumbCatalog filterService={filterService} filterByBrand ={filterByBrand} filters={filters} categories={categories} />
                    <Shortcuts location={location} />
                    <BannerShelf location={location}/>
                    <ShelfHeader title={title} quantity={quantity} filter={filterService} filters={sideFilters} specifications={specifications} searchWord={searchTerm}/>
                    <Shelf title={title} filter={filterService} categories={categories} specifications={specifications} filters={filters} changeQuantity={changeQuantity} />
                    <BannerShelf location={location} position={'bottom'} />
                    <TextComponent location={location} data={dataTexComponent}/>
                </main>
            </div>}
        </div>
    )
}

CatalogContainer.propTypes = {
    searchTerm: PropTypes.string,
    isLoaded: PropTypes.bool,
    categories: PropTypes.array,
    sideFilters: PropTypes.object,
    filters: PropTypes.object,
    filterByBrand: PropTypes.bool,
    filterService: PropTypes.object,
    location: PropTypes.object,
    specifications: PropTypes.array,
    title: PropTypes.string,
    shortcuts: PropTypes.object,
};

export default CatalogContainer;
